import HeadNav from "../../components/HeadNav";
import TabBar from "../../components/TabBar"
import {cutPhone, cutPhone1, showTotalData, fmDate, encrypt, LZStringCompress} from "../../tools";
import {Toast} from 'vant';
import ListEmpty from "../../components/ListEmpty";
import {
  setUnit1,
  getUserTotalIncomeAllPool2,
  getUserTotalIncomeCurrentPool2,
  getUserTotalDepositAPool2,
  getUserTotalDepositBPool2,
  getDepositInfoArrPool2,
  withdrawTotalDistributionIncomePool2,
  getUserTotalIncomeAPool2,
  getUserTotalIncomeBPool2
} from "../../tools/chain";
import Clipboard from "clipboard";
import {contractAddress} from "../../config";
import {BigNumberStr,BigNumberMul,BigNumberDiv,BigNumberAdd,BigNumberSub} from "../../tools/indexFun";
let bCure = false;
export default {
  name: "TrusteeshipDetails",
  components: {
    HeadNav,
    TabBar,
    ListEmpty
  },
  data() {
    return {
      showShare: false,
      show: false,
      tabIndex: '',
      userTotalDepositAll: 0,
      userTotalDepositA: 0,
      userTotalDepositB: 0,
      userTotalIncomeAll: 0,
      userTotalIncomeA: 0,
      userTotalIncomeB: 0,
      userTotalIncomeCurrent: 0,
      depositLog: [],
    }

  },
  created() {
  },
  methods: {
    BigNumberStr(num1,num2,col){
      return BigNumberStr(num1,num2,col);
    },
    showToast(){
      Toast.fail({
        message:this.langUtil(89)
      })
    },
    showTotalData(data) {
      return showTotalData(data)
    },
    //获取收益总金额
    async getUserTotalIncomeAllPool2(){
      this.userTotalIncomeAll = await getUserTotalIncomeAllPool2(this.$store.state.accounts[0]);
    },
    async getUserTotalIncomeAPool2(){
      this.userTotalIncomeA = await getUserTotalIncomeAPool2(this.$store.state.accounts[0]);
    },
    async getUserTotalIncomeBPool2(){
      this.userTotalIncomeB = await getUserTotalIncomeBPool2(this.$store.state.accounts[0]);
    },
    async getUserTotalIncomeCurrentPool2(){
      this.userTotalIncomeCurrent = await getUserTotalIncomeCurrentPool2(this.$store.state.accounts[0]);
    },
    async getUserTotalDepositAPool2(){
      this.userTotalDepositA = await getUserTotalDepositAPool2(this.$store.state.accounts[0]);
    },
    async getUserTotalDepositBPool2(){
      this.userTotalDepositB = await getUserTotalDepositBPool2(this.$store.state.accounts[0]);
    },
    async getDepositLog() {
      this.depositLog = await getDepositInfoArrPool2(1, 200, this.$store.state.accounts[0]);
    },
    async refresh() {
      this.getUserTotalIncomeAllPool2();
      this.getUserTotalIncomeAPool2();
      this.getUserTotalIncomeBPool2();
      this.getUserTotalIncomeCurrentPool2();
      this.getUserTotalDepositAPool2();
      this.getUserTotalDepositBPool2();
      this.getDepositLog();
    },
    async onWithdraw(){
      if (this.userTotalIncomeCurrent == '0'){
        Toast.fail({
          message: this.langUtil(80),
        })
      } else {
        await withdrawTotalDistributionIncomePool2();
        Toast.success({
          message:this.langUtil(72)
        })
      }
      await this.refresh();
    },
    cutPhone(phone) {
      return cutPhone(phone);
    },
    cutPhone1(phone) {
      return cutPhone1(phone);
    },
    setUnit1(phone) {
      return setUnit1(phone);
    },
    fmDate(phone) {
      return fmDate(phone);
    },
  },
  mounted() {
    this.refresh();
  }
}
